<script>
export default {
  props: {
    url: {type: String, required: true},
    size: {type: String, required: true}
  },
  data () {
    return {
      index: this.$parent.$children.indexOf(this),
      options: {
        src: this.url,
        w: this.size.split('x')[0],
        h: this.size.split('x')[1],
        title: null
      }
    }
  },
  methods: {
    openImage: function () {
      this.$emit('open-gallery', this.index);
    }
  }
}
</script>



// WEBPACK FOOTER //
// assets/js/components/content/gallery/GalleryImage.vue